import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@core/i18n/i18n.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgApexchartsModule } from 'ng-apexcharts';
import { InlineSVGModule } from 'ng-inline-svg';
import { CurrencyComponent } from './components/currency/currency.component';
import { FacilitiesItemComponent } from './components/facilities/facilities-item/facilities-item.component';
import { FacilitiesListItemComponent } from './components/facilities/facilities-list-item/facilities-list-item.component';
import { FacilitiesListComponent } from './components/facilities/facilities-list/facilities-list.component';
import { ListMenuComponent } from './components/list-menu/list-menu.component';
import { LoaderComponent } from './components/loader/loader.component';
import { RootModalComponent } from './components/root-modal/root-modal.component';
import { DecimalNumberDirective } from './directive/decimal-number.directive';
import { ScrollVanishDirective } from './directive/scroll-vanish.directive';
import { DateFormatPipe } from './pipes/format/date-format.pipe';
import { DateTimeFormatPipe } from './pipes/format/date-time-format.pipe';
import { NumberFormatPipe } from './pipes/format/number-format.pipe';
import { TimeFormatPipe } from './pipes/format/time-format.pipe';
import { BorcAlacakAramaPipe } from './pipes/search/borc-alacak-arama.pipe';
import { HesapBilgileriAramaPipe } from './pipes/search/hesap-bilgileri-arama.pipe';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    I18nModule,
    InlineSVGModule,
    SweetAlert2Module,
    NgApexchartsModule
  ],
  declarations: [
    LoaderComponent,
    DecimalNumberDirective,
    ScrollVanishDirective,
    DateFormatPipe,
    DateTimeFormatPipe,
    TimeFormatPipe,
    NumberFormatPipe,
    HesapBilgileriAramaPipe,
    BorcAlacakAramaPipe,
    FacilitiesItemComponent,
    FacilitiesListComponent,
    FacilitiesListItemComponent,
    ListMenuComponent,
    RootModalComponent,
    CurrencyComponent,
  ],
  exports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    I18nModule,
    InlineSVGModule,
    SweetAlert2Module,
    NgApexchartsModule,
    DecimalNumberDirective,
    ScrollVanishDirective,
    DateFormatPipe,
    DateTimeFormatPipe,
    TimeFormatPipe,
    NumberFormatPipe,
    HesapBilgileriAramaPipe,
    BorcAlacakAramaPipe,
    FacilitiesItemComponent,
    ListMenuComponent,
    RootModalComponent,
    CurrencyComponent
  ]
})
export class SharedModule { }
